var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8.46667 8H7.53333C7.23878 8 7 8.23878 7 8.53333V11.4667C7 11.7612 7.23878 12 7.53333 12H8.46667C8.76122 12 9 11.7612 9 11.4667V8.53333C9 8.23878 8.76122 8 8.46667 8ZM8.46667 4H7.53333C7.23878 4 7 4.23878 7 4.53333V5.46667C7 5.76122 7.23878 6 7.53333 6H8.46667C8.76122 6 9 5.76122 9 5.46667V4.53333C9 4.23878 8.76122 4 8.46667 4Z",
    fill: "#FAB73B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconFilled);
export default __webpack_public_path__ + "static/media/info_icon_filled.35c6f7235c59431be5c59319fb5ee24e.svg";
export { ForwardRef as ReactComponent };